import { buildHeaders, buildRequest, buildUrl, fetchRequest } from '../utils/apis/RestApi';
import { handleError } from '../business/helpers';

export const logout = async () => {
  const url = buildUrl('ICARE_BACK', 'auth/end-session');
  const headers = buildHeaders();
  const request = buildRequest(url, 'DELETE', headers);

  try {
    await fetchRequest(request);

    globalThis.location.reload();
  } catch (e) {
    handleError();
  }
};
